import ChevronLeft from "@website/icons/components/chevron-left";
import ChevronRight from "@website/icons/components/chevron-right";
import { MonthActionsPropertiesType } from "@website/ui-old/datepicker/components/month-actions/month-actions.types";

/**
 * @deprecated please use @website/ui instead
 */
export const useMonthActions = (properties: MonthActionsPropertiesType) => {
  const {
    calendarLocale,
    showPreviousMonth,
    showNextMonth,
    nextMonthDisabled,
    previousMonthDisabled
  } = properties;

  return {
    showPreviousMonthButtonProperties: {
      onClick: showPreviousMonth,
      EndIcon: <ChevronLeft />,
      color: "neutral" as const,
      size: "small" as const,
      variant: "text" as const,
      "aria-label":
        calendarLocale === "persian" ? "نمایش ماه قبل" : "show-previous-month",
      equalDimension: true,
      disabled: previousMonthDisabled
    },
    showNextMonthButtonProperties: {
      onClick: showNextMonth,
      EndIcon: <ChevronRight />,
      color: "neutral" as const,
      size: "small" as const,
      variant: "text" as const,
      "aria-label":
        calendarLocale === "persian" ? "نمایش ماه بعد" : "show-next-month",
      equalDimension: true,
      disabled: nextMonthDisabled
    }
  };
};
